<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="ListSOR && AccessAllowed" class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Statement of Risks
    </h3></div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Statements of Risk allow you to define various risks associated with a resource.  For example you may have a resource that requires users to accept a liability waiver before they can use the resource.  You would create a Statement of Risk for the liability waiver and then associate that Statement of Risk with the resource.
    </p>
    <div style="text-align: right; margin-bottom: 20px;">

        <span class="p-input-icon-left ml-auto" style="margin-right:20px; "> 
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="sorTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Notes"/>
        </span>
        
        <button *ngIf="ListSOR.data == null || ListSOR.data.length == 0" pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" [routerLink]="['/statementofriskedit/0']" i18>
            <span class="pi pi-plus" style="margin-right:8px;"></span>
            <span i18>Add</span>
        </button>

        <button *ngIf="ListSOR.data != null && ListSOR.data.length > 0" disabled="true" pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component">
            <span class="pi pi-plus" style="margin-right:8px;"></span>
            <span i18>Add</span>
        </button>

    </div>
    <div style="border: 2px solid #ef4444;border-radius: 15px;margin: 20px;padding:20px;">
        <div style="float:left; width: 80px;;text-align: center;">
            <span class="pi pi-exclamation-triangle" style="margin-right:5px;color:orange;font-size:50px;margin-top:14px;"></span>
        </div>
        <div style="float:left; width: calc(100% - 80px)">
            <b>LEGAL RESPONSIBILITY REMINDER</b><br>
            You are creating legally binding waiver content. Ensure that you have obtained professional legal advice to ensure that your waiver is enforceable and complies with all relevant laws and regulations. WannaBook <b>does not</b> review or validate this content.
        </div>
    </div>
    <div class="surface-card p-4 shadow-2 border-round">
    <p-table  #sorTable 
    [value]="ListSOR.data" sortField="enddate" [sortOrder]="-1" [paginator]="true" [rows]="10" 
    [showCurrentPageReport]="true" responsiveLayout="scroll"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" 
    [rowsPerPageOptions]="[10,25,50]" 
    [globalFilterFields]="['name']"
    [(selection)]="selectedItems"
    responsiveLayout="scroll"
    datakey="sorid"
    [selectionPageOnly]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pSortableColumn="name" width="60%">Notes
                    <p-sortIcon [field]="name"></p-sortIcon>
                </th>
                <th pSortableColumn="name" width="10%">SOR ID
                    <p-sortIcon [field]="soridhr"></p-sortIcon>
                </th>
                <th pSortableColumn="name" width="10%">Start Date
                    <p-sortIcon [field]="name"></p-sortIcon>
                </th>
                <th pSortableColumn="name" width="10%">End Date
                    <p-sortIcon [field]="name"></p-sortIcon>
                </th>
                <th width="5%"></th>
                <th width="5%"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                <td>
                    <p-tableCheckbox [value]="data"></p-tableCheckbox>
                </td>
                <td>{{data.name}}</td>
                <td>{{data.soridhr}}</td>
                <td>{{data.startdate | date:'dd/MM/yyyy'}}</td>
                <td>{{data.enddate | date:'dd/MM/yyyy'}}</td>
                <td *ngIf="data.isactive==true">
                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="background-color: yellow o !important;width:135px;" (click)="editData(data.sorid);" i18>
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    <span i18n>Edit</span>
                </button>
                </td>

                <td *ngIf="data.isactive==false">
                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="background-color: yellow o !important;width:135px;" (click)="editData(data.sorid);">
                    <span class="pi pi-eye" style="margin-right:8px;"></span>
                    <span i18n>View</span>
                </button>
                </td>

                <td *ngIf="data.isactive==true">
                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" style="background-color: yellow o !important;width:135px;" (click)="printwaiver();">
                    <span class="pi pi-file-pdf" style="margin-right:8px;"></span>
                    <span i18n>View/Print</span>
                </button>
                </td>
                <td *ngIf="data.isactive==false">
                    <button disabled="false" pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" style="background-color: yellow o !important;width:135px;">
                    <span class="pi pi-file-pdf" style="margin-right:8px;"></span>
                    <span i18n>View/Print</span>
                </button>
                </td>
            </tr>
        </ng-template>
    </p-table>
    </div>
</div>
